// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //

import GroupsIcon from '@mui/icons-material/Groups';

const TeamRoutes = {
  id: 'Team-group',
  title: 'Team Management',
  type: 'group',
  children: [
    {
      id: 'Team-list',
      title: 'Team List',
      type: 'item',
      url: '/team/list',
      icon: GroupsIcon,
      target: false
    }
  ]
};

export default TeamRoutes;
